import LogsTable from './logsTable.view';

export default LogsTable;
